import React from 'react'
import { DropdownItem } from './styles'

export type AssigneeTab = 'users' | 'groups'

const ASSIGNEE_TABS: { id: AssigneeTab; name: string }[] = [
  { id: 'users', name: 'Users' },
  { id: 'groups', name: 'User groups' },
]

// Tabs across the top of a dropdown menu, such as Users / User groups.
export const DropdownTabs = <T extends string>({
  tabs,
  active,
  onChange,
  label,
}: {
  tabs: { id: T; name: string }[]
  active: T
  onChange: (tab: T) => void
  label: string
}): JSX.Element => (
  <div
    role="tablist"
    aria-label={label}
    style={{ display: 'flex', marginBottom: 8 }}
  >
    {tabs.map(({ id, name }, i) => (
      <DropdownItem
        key={id}
        role="tab"
        aria-selected={active === id}
        style={{
          whiteSpace: 'nowrap',
          fontWeight: active === id ? 600 : 400,
          borderBottom:
            active === id ? '2px solid currentColor' : '2px solid transparent',
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            const step = e.key === 'ArrowRight' ? 1 : tabs.length - 1
            onChange(tabs[(i + step) % tabs.length].id)
            const sibling =
              e.key === 'ArrowRight'
                ? e.currentTarget.nextElementSibling ??
                  e.currentTarget.parentElement?.firstElementChild
                : e.currentTarget.previousElementSibling ??
                  e.currentTarget.parentElement?.lastElementChild
            ;(sibling as HTMLButtonElement | null | undefined)?.focus()
          }
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onChange(id)
        }}
      >
        {name}
      </DropdownItem>
    ))}
  </div>
)

// Users / User groups tabs, for a dropdown that lists both kinds of assignee.
export const AssigneeTypeTabs = ({
  active,
  onChange,
}: {
  active: AssigneeTab
  onChange: (tab: AssigneeTab) => void
}): JSX.Element => (
  <DropdownTabs
    tabs={ASSIGNEE_TABS}
    active={active}
    onChange={onChange}
    label="Assignee type"
  />
)
